
import { ApiConfig } from '../../Config';
import axios from 'axios';

var VerifyOtpLoginTelCtrl = function (fn, er, telephone, otp, token, ids) {

    var config = {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json',
            'MT_SESSION_ID': ids
        },

    };
    var data = {
        newCellNumber: telephone,
        otp: otp
    };


    axios
        .post(ApiConfig.url.OTP_TEL_LOGIN, data, config)
        .then(function (result) {
            fn(result.data, result.status)
        })
        .catch(function (error) {
            er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500,
               error !== undefined && error.response !== undefined && error.response.data !== undefined && error.response.data.details !== undefined ? error.response.data.details[0] : '5709')
        });


}

export { VerifyOtpLoginTelCtrl };